/* WorldClass theme behaviour — small, dependency-free, progressive.
   Everything here degrades gracefully: without JS the pages still work. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(root = document) {
    const els = $$('.wc-reveal:not(.is-in)', root);
    if (!els.length) return;
    document.documentElement.classList.add('wc-js');
    const inView = (el) => { const r = el.getBoundingClientRect(); return r.top < window.innerHeight * 1.15 && r.bottom > 0; };
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    els.forEach(e => { if (inView(e)) e.classList.add('is-in'); });
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 10% 0px', threshold: 0 });
    els.forEach(e => { if (!e.classList.contains('is-in')) io.observe(e); });
    // Safety net: nothing stays hidden for long, whatever the browser does with observers.
    setTimeout(() => els.forEach(e => e.classList.add('is-in')), 3000);
  }

  /* ---------------- Hero slideshow ---------------- */
  function initHero(hero) {
    const slides = $$('[data-wc-hero-slide]', hero);
    const dots = $$('[data-wc-hero-dot]', hero);
    if (slides.length < 2) return;
    let i = 0, timer = null;
    const autoplay = hero.dataset.autoplay === 'true' && !reduceMotion;
    const speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
    const go = (n) => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
    };
    const start = () => { if (autoplay) timer = setInterval(() => go(i + 1), speed); };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    dots.forEach((d, n) => d.addEventListener('click', () => { stop(); go(n); start(); }));
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop); hero.addEventListener('focusout', start);
    // swipe
    let x0 = null;
    hero.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { stop(); go(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
    start();
  }

  /* ---------------- Marquee: duplicate track for seamless loop ---------------- */
  function initMarquee(m) {
    const track = $('.wc-marquee__track', m);
    if (!track || track.dataset.cloned) return;
    track.dataset.cloned = '1';
    if (reduceMotion) return;
    const clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.append(...Array.from(clone.children));
    const items = track.children.length / 2;
    track.style.setProperty('--wc-marquee-speed', Math.max(25, items * 4) + 's');
  }

  /* ---------------- Tabs (origins) ---------------- */
  function initTabs(root) {
    const tabs = $$('[role="tab"]', root);
    const panels = $$('[role="tabpanel"]', root);
    if (!tabs.length) return;
    const select = (n) => {
      tabs.forEach((t, k) => { t.setAttribute('aria-selected', k === n ? 'true' : 'false'); t.tabIndex = k === n ? 0 : -1; });
      panels.forEach((p, k) => p.classList.toggle('is-active', k === n));
    };
    tabs.forEach((t, n) => {
      t.addEventListener('click', () => select(n));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); tabs[(n + 1) % tabs.length].focus(); select((n + 1) % tabs.length); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); tabs[(n - 1 + tabs.length) % tabs.length].focus(); select((n - 1 + tabs.length) % tabs.length); }
      });
    });
    select(0);
  }

  /* ---------------- Scroller nav buttons ---------------- */
  function initScrollers(root = document) {
    $$('[data-wc-scroller]', root).forEach(wrap => {
      const track = $('.wc-scroller', wrap);
      if (!track) return;
      $$('[data-wc-scroll]', wrap).forEach(btn => btn.addEventListener('click', () => {
        const dir = btn.dataset.wcScroll === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: reduceMotion ? 'auto' : 'smooth' });
      }));
    });
  }

  /* ---------------- Delivery promise ---------------- */
  // Computes "Order by Tue 12:00 PM · ships Wed · arrives Fri" in US Central,
  // from data attributes: data-ship-days="1,2,3" data-cutoff="12" data-transit="2"
  const DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function centralNow() {
    try {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', weekday: 'short' }).formatToParts(new Date());
      const g = (t) => parts.find(p => p.type === t).value;
      const d = new Date(+g('year'), +g('month') - 1, +g('day'), +g('hour') % 24, +g('minute'));
      return d;
    } catch (e) { return new Date(); }
  }
  function fmtDay(d, withDate) { return DAY[d.getDay()] + (withDate ? ' ' + MON[d.getMonth()] + ' ' + d.getDate() : ''); }
  function fmtHour(h) { const ap = h >= 12 ? 'PM' : 'AM'; const hh = h % 12 || 12; return hh + ':00 ' + ap; }
  function computePromise(el) {
    const shipDays = (el.dataset.shipDays || '1,2,3').split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));
    const cutoff = parseInt(el.dataset.cutoff, 10) || 12;
    const transit = parseInt(el.dataset.transit, 10) || 2;
    if (!shipDays.length) return null;
    const now = centralNow();
    let ship = null, offset = 0;
    for (let d = 0; d < 21; d++) {
      const c = new Date(now.getFullYear(), now.getMonth(), now.getDate() + d);
      if (!shipDays.includes(c.getDay())) continue;
      if (d === 0 && (now.getHours() >= cutoff)) continue;
      ship = c; offset = d; break;
    }
    if (!ship) return null;
    // arrival: transit business days, skipping Sunday
    const arrive = new Date(ship);
    let added = 0;
    while (added < transit) { arrive.setDate(arrive.getDate() + 1); if (arrive.getDay() !== 0) added++; }
    const cutoffDate = new Date(ship.getFullYear(), ship.getMonth(), ship.getDate(), cutoff, 0);
    const msLeft = cutoffDate - now;
    return { ship, arrive, offset, cutoff, msLeft };
  }
  function renderPromise(el) {
    const p = computePromise(el);
    const out = $('[data-wc-promise-text]', el) || el;
    if (!p) { out.textContent = el.dataset.fallback || ''; return; }
    const prefix = el.dataset.prefix || 'Order by';
    let lead = '';
    if (p.offset === 0 && p.msLeft > 0 && p.msLeft < 12 * 3600e3) {
      const h = Math.floor(p.msLeft / 3600e3), m = Math.floor((p.msLeft % 3600e3) / 60e3);
      lead = `<strong>Order in the next ${h ? h + 'h ' : ''}${m}m</strong> and it ships today (${fmtDay(p.ship)}).`;
    } else {
      lead = `<strong>${prefix} ${fmtDay(p.ship)} ${fmtHour(p.cutoff)} CT</strong> · ships ${fmtDay(p.ship, true)}.`;
    }
    out.innerHTML = `${lead} <span class="wc-ship-line__sub">Arrives ${fmtDay(p.arrive, true)}. ${el.dataset.note || ''}</span>`;
  }
  function initPromises(root = document) { $$('[data-wc-promise]', root).forEach(renderPromise); }

  /* ---------------- PDP ---------------- */
  function money(cents, fmt) {
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const withCommas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withCommas + '.' + d);
    return '$' + withCommas + '.' + d;
  }
  function initPdp(pdp) {
    const dataEl = $('[data-wc-product-json]', pdp);
    const product = dataEl ? JSON.parse(dataEl.textContent) : null;
    const fmt = pdp.dataset.moneyFormat || '';
    // gallery
    const items = $$('.wc-pdp__media-item', pdp);
    const thumbs = $$('.wc-pdp__thumb', pdp);
    const showMedia = (id) => {
      items.forEach(it => it.classList.toggle('is-active', String(it.dataset.mediaId) === String(id)));
      thumbs.forEach(t => t.classList.toggle('is-active', String(t.dataset.mediaId) === String(id)));
      items.forEach(it => { const v = $('video', it); if (v && !it.classList.contains('is-active')) v.pause(); });
    };
    thumbs.forEach(t => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));
    // quantity
    const qty = $('[data-wc-qty]', pdp);
    if (qty) {
      const input = $('input', qty);
      $$('button', qty).forEach(b => b.addEventListener('click', () => { const n = Math.max(1, (parseInt(input.value, 10) || 1) + (b.dataset.dir === 'up' ? 1 : -1)); input.value = n; }));
    }
    if (!product) return;
    // variants
    const form = $('form[data-wc-product-form]', pdp);
    const idInput = form && $('input[name="id"]', form);
    const priceEl = $('[data-wc-price]', pdp);
    const compareEl = $('[data-wc-compare]', pdp);
    const unitEl = $('[data-wc-unit]', pdp);
    const addBtn = $('[data-wc-add]', pdp);
    const addLabel = addBtn && $('[data-wc-add-label]', addBtn);
    const stickyPrice = $('[data-wc-sticky-price]');
    const stickyBtn = $('[data-wc-sticky-add]');
    const optionInputs = $$('[data-wc-option]', pdp);
    const outputs = $$('[data-wc-option-value]', pdp);
    const selected = () => optionInputs.filter(i => i.checked || i.tagName === 'SELECT').map(i => i.value);
    const findVariant = () => {
      const sel = selected();
      return product.variants.find(v => v.options.every((o, k) => o === sel[k])) || null;
    };
    const update = () => {
      const v = findVariant();
      outputs.forEach((o, k) => { const s = selected()[k]; if (s) o.textContent = s; });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addLabel && (addLabel.textContent = addBtn.dataset.unavailable || 'Unavailable'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, fmt);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price, fmt); compareEl.hidden = false; } else compareEl.hidden = true; }
      if (unitEl) {
        if (v.unit_price && v.unit_price_measurement) unitEl.textContent = money(v.unit_price, fmt) + ' / ' + v.unit_price_measurement.reference_unit;
        else unitEl.textContent = unitEl.dataset.static || '';
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? (addBtn.dataset.add || 'Add to cart') : (addBtn.dataset.soldout || 'Sold out');
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price, fmt);
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
      // availability strike-through per pill (only for first option, cheap heuristic)
      optionInputs.forEach(inp => {
        const pill = inp.closest('.wc-pill'); if (!pill) return;
        const idx = parseInt(inp.dataset.wcOption, 10);
        const test = selected().slice(); test[idx] = inp.value;
        const match = product.variants.find(vv => vv.options.every((o, k) => o === test[k]));
        pill.classList.toggle('is-unavailable', !match || !match.available);
      });
      try { const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); } catch (e) {}
    };
    optionInputs.forEach(i => i.addEventListener('change', update));
    update();
    // sticky ATC
    const sticky = $('.wc-sticky-atc');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
      io.observe(addBtn);
      stickyBtn && stickyBtn.addEventListener('click', () => { addBtn.click(); });
    }
  }

  /* ---------------- Collection filters (auto-submit) ---------------- */
  function initFilters(root = document) {
    const form = $('#WcFacetForm', root);
    if (form) {
      let t;
      form.addEventListener('change', (e) => {
        if (e.target.matches('[data-wc-filter-input]')) { clearTimeout(t); t = setTimeout(() => form.requestSubmit ? form.requestSubmit() : form.submit(), 250); }
      });
    }
    const sort = $('[data-wc-sort]', root);
    if (sort) sort.addEventListener('change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
    const toggle = $('[data-wc-filters-toggle]', root);
    const panel = $('.wc-filters', root);
    if (toggle && panel) toggle.addEventListener('click', () => { const open = panel.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }

  /* ---------------- Header overlay on homepage ---------------- */
  function initHeader() {
    const wrapper = $('.header-wrapper');
    if (!wrapper) return;
    const h = wrapper.offsetHeight; if (h) document.documentElement.style.setProperty('--wc-header-height', h + 'px');
  }

  /* ---------------- Boot ---------------- */
  function boot(root = document) {
    initReveal(root);
    $$('[data-wc-hero]', root).forEach(initHero);
    $$('.wc-marquee', root).forEach(initMarquee);
    $$('[data-wc-tabs]', root).forEach(initTabs);
    initScrollers(root);
    initPromises(root);
    $$('[data-wc-pdp]', root).forEach(initPdp);
    initFilters(root);
    initHeader();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  // Theme editor: re-init sections when they load/re-render
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  // Cart drawer re-renders replace our promise snippet; re-run
  document.addEventListener('cart:updated', () => initPromises());
  window.WCTheme = { boot, initPromises };
})();
